/* eslint-disable no-nested-ternary */
import { memo } from 'react'

import Popup from 'components/common/Popup'
import Card from 'components/common/Card'
import { useTranslation } from 'services/Translation'

import EN from './content/en'
import NL from './content/nl'

const Privacy = ({ active, onClose, onlyText }) => {
  const { lang } = useTranslation()

  return !active ? null : (
    <>
      {onlyText ? (
        lang === 'nl' ? (
          <NL />
        ) : (
          <EN />
        )
      ) : (
        <Popup onOverlayClick={onClose} contentWidth={50}>
          <Card style={{ overflow: 'auto', margin: '32px 0' }}>
            {lang === 'nl' ? <NL /> : <EN />}
          </Card>
        </Popup>
      )}
    </>
  )
}

Privacy.whyDidYouRender = true

export default memo(Privacy)
